import styled from 'styled-components';


export const CardWrapper = styled.div`
    min-width: 250px;
    margin-bottom: 18px;
`